import { Header } from './Header.js'
import { Footer } from './Footer.js'

import './Pricing.css'

export function Pricing () {
  return (
    <div>
      <Header activeItem='pricing' />
      <main>
        <section className='pricing-hero'>
          <div className='container'>
            <h1>Our Pricing</h1>
            <p>Choose the perfect package for your event</p>
          </div>
        </section>

        <section className='pricing-plans'>
          <div className='container'>
            <div className='pricing-grid'>
              <article className='pricing-card'>
                <h2>Basic Package</h2>
                <p className='price'>$50</p>
                <ul className='features'>
                  <li>Table</li>
                  <li>Silverware</li>
                  <li>Plates</li>
                  <li>Decor</li>
                  <li>Pillow</li>
                  <li>Games</li>
                </ul>
                <a href='book?packageType=basic' className='button'>
                  Book Now
                </a>
              </article>
              <article className='pricing-card'>
                <h2>Deluxe Package</h2>
                <p className='price'>$75</p>
                <ul className='features'>
                  <li>Table</li>
                  <li>Silverware</li>
                  <li>Decor</li>
                  <li>Pillows</li>
                  <li>Games</li>
                  <li>Bubble Tent</li>
                  <li>Bottle of Martinellis</li>
                  <li>Heater/Fan</li>
                </ul>
                <a href='book?packageType=deluxe' className='button'>
                  Book Now
                </a>
              </article>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  )
}
